import {cn} from '../lib/utils';
import {Icons} from '../icons';

interface Props {
  contentType?: string;
  name?: string;
  className?: string;
  iconClass?: string;
  extentionClass?: string;
}

function getExtension(contentType?: string, name?: string): string | undefined {
  if (name) {
    const parts = name.split('.');
    if (parts.length > 1) {
      return parts.pop()!.toLowerCase();
    }
  }
  if (contentType) {
    const mime = contentType.toLowerCase();
    if (mime.includes('pdf')) {
      return 'pdf';
    }
    if (mime.includes('presentation') || mime.includes('powerpoint')) {
      return 'pptx';
    }
    if (mime.includes('word') || mime.includes('msword')) {
      return 'docx';
    }
    if (mime.includes('spreadsheet') || mime.includes('excel')) {
      return 'xlsx';
    }
  }
  return undefined;
}

function getBadgeColor(ext?: string): string {
  switch (ext) {
    case 'pdf':
      return 'bg-destructive';
    case 'ppt':
    case 'pptx':
      return 'bg-orange-500';
    case 'doc':
    case 'docx':
      return 'bg-blue-500';
    case 'xls':
    case 'xlsx':
      return 'bg-green-600';
    case 'csv':
      return 'bg-emerald-600';
    case 'json':
      return 'bg-amber-500';
    case 'xml':
      return 'bg-amber-600';
    case 'yaml':
    case 'yml':
      return 'bg-rose-500';
    case 'md':
      return 'bg-slate-600';
    case 'html':
    case 'htm':
      return 'bg-orange-600';
    case 'png':
      return 'bg-sky-500';
    case 'jpg':
    case 'jpeg':
      return 'bg-cyan-600';
    case 'gif':
      return 'bg-teal-600';
    case 'webp':
      return 'bg-lime-600';
    case 'svg':
      return 'bg-red-500';
    default:
      return 'bg-muted-foreground';
  }
}

export const DocumentIcon = ({
  contentType,
  name,
  className,
  iconClass,
  extentionClass,
}: Props) => {
  const ext = getExtension(contentType, name);
  const badgeColor = getBadgeColor(ext);

  return (
    <div className={cn('relative inline-flex', className)}>
      <Icons.file className={cn('size-6 text-muted-foreground', iconClass)} />
      {ext && (
        <span
          className={cn(
            'absolute bottom-1.5 -left-1.5 rounded-sm px-0.5 text-[8px] font-bold uppercase leading-tight text-white',
            badgeColor,
            extentionClass,
          )}
        >
          {ext}
        </span>
      )}
    </div>
  );
};
